import React from "react";

/**COMPONENTS IMPORT */
import PageHero from "../Components/PageHero";

const Services=()=>{
    return(
        <>

    {/**HERO SECTION */}
    <PageHero heading={"Services"}/>
        </>
    )
}

export default Services;